import {
    isEmailRule,
    isEmptyRule,
    isMinLengthRule,
    isNoSymbolsRule,
    isPhoneRule,
} from "./rules"
import { IProfileValidations } from "./validationRule"

// validations object, give each field the rule you need

export const validations: IProfileValidations = {
    first_name: [isEmptyRule, isMinLengthRule, isNoSymbolsRule],
    last_name: [isEmptyRule, isMinLengthRule, isNoSymbolsRule],
    email: [isEmptyRule, isEmailRule],
    phone: [isEmptyRule, isPhoneRule],
}
